module.exports = __webpack_public_path__ + "media/images/icons/arrow_left-00266aaacc73a770123e1ace8f63e62f.svg";